module.exports = __webpack_public_path__ + "assets/f7ee2cdd3489de66a77a9f5176cbd47a.png";